import Config from "../config";

const billingBaseUrl = `${Config.site_api}/v1/admin/billing`;

const adminAuthBaseUrl = `${Config.site_api}/v1/platform/auth`;

const platformBaseUrl = `${Config.site_api}/v1/platform`;

const businessBaseUrl = `${Config.site_api}/v1/platform`;

export const config = {
  // FORGOT PASSWORD
  adminForgotPasswordSendOtp: `${Config.site_api}/v1/admin/auth/forgot-password/send-otp`,

  adminForgotPasswordVerifyOtp: `${Config.site_api}/v1/admin/auth/forgot-password/verify-otp`,

  adminForgotPasswordReset: `${Config.site_api}/v1/admin/auth/forgot-password/reset`,
  // PLATFORM AUTH
  platformLogin: `${Config.site_api}/v1/platform/auth/login`,

  getPlatformProfile: `${Config.site_api}/v1/platform/auth/me`,

  // TENANT AUTH
  login: `${Config.site_api}/v1/admin/auth/login`,

  tenantLogin: `${Config.site_api}/v1/admin/auth/tenant-login`,

  getTenantProfile: `${Config.site_api}/v1/admin/auth/me`,

  // PLATFORM URL
  getPlatformDashboard: `${platformBaseUrl}/dashboard`,

  getPlatformDashboardSummary: `${platformBaseUrl}/dashboard/summary`,

  getPlatformRecentBusinesses: `${platformBaseUrl}/dashboard/recent-businesses`,

  getPlatformBusinessGrowth: `${platformBaseUrl}/dashboard/business-growth`,

  getPlatformSubscriptionSummary: `${platformBaseUrl}/dashboard/subscriptions`,

  // BUSINESS URL

  getPlatformBusinesses: `${platformBaseUrl}/business`,

  getPlatformBusinessById: (id) => `${platformBaseUrl}/business/${id}`,

  createPlatformBusiness: `${platformBaseUrl}/business`,

  updatePlatformBusiness: (id) => `${platformBaseUrl}/business/${id}`,

  activatePlatformBusiness: (id) =>
    `${platformBaseUrl}/business/${id}/activate`,

  suspendPlatformBusiness: (id) => `${platformBaseUrl}/business/${id}/suspend`,

  platformTenantUsers: `${Config.site_api}/v1/platform/tenant-users`,

  platformTenantUserFilters: `${Config.site_api}/v1/platform/tenant-users/filters`,

  platformTenantUserById: (id) =>
    `${Config.site_api}/v1/platform/tenant-users/${id}`,

  platformTenantUserStatus: (id) =>
    `${Config.site_api}/v1/platform/tenant-users/${id}/status`,

  // PLATFORM ACTIVITY
  platformActivity: `${Config.site_api}/v1/platform/activity`,

  platformActivityFilters: `${Config.site_api}/v1/platform/activity/filters`,

  platformActivityById: (id) => `${Config.site_api}/v1/platform/activity/${id}`,

  platformSettings: `${Config.site_api}/v1/platform/settings`,
  platformSubscriptionPlans: `${Config.site_api}/v1/platform/subscription-plans`,

  platformSubscriptionPlanById: (id) =>
    `${Config.site_api}/v1/platform/subscription-plans/${id}`,

  platformSubscriptionPlanStatus: (id) =>
    `${Config.site_api}/v1/platform/subscription-plans/${id}/status`,

  assignTenantSubscriptionPlan: (tenantId) =>
    `${Config.site_api}/v1/platform/tenant-subscriptions/tenant/${tenantId}/assign-plan`,

  syncPlatformTenantPlanAccess: `${Config.site_api}/v1/platform/subscription-plans/sync-tenants`,
  
  platformSubscriptionModules: `${Config.site_api}/v1/platform/subscription-plans/modules`,

  // LEAD BUSINESS PARTNER
  platformBusinessPartnerLeads: `${Config.site_api}/v1/admin/platform/business-partner-leads`,

  platformBusinessPartnerLeadSummary: `${Config.site_api}/v1/admin/platform/business-partner-leads/summary`,

  platformBusinessPartnerLeadFilters: `${Config.site_api}/v1/admin/platform/business-partner-leads/filters`,

  platformBusinessPartnerLeadById: (id) =>
    `${Config.site_api}/v1/admin/platform/business-partner-leads/${id}`,

  platformBusinessPartnerLeadStatus: (id) =>
    `${Config.site_api}/v1/admin/platform/business-partner-leads/${id}/status`,

  platformBusinessPartnerLeadAssign: (id) =>
    `${Config.site_api}/v1/admin/platform/business-partner-leads/${id}/assign`,

  platformBusinessPartnerLeadNotes: (id) =>
    `${Config.site_api}/v1/admin/platform/business-partner-leads/${id}/notes`,

  platformBusinessPartnerLeadConvert: (id) =>
    `${Config.site_api}/v1/admin/platform/business-partner-leads/${id}/convert`,

  // SELL DEVICE LEAD
  platformSellDeviceLeads: `${Config.site_api}/v1/admin/platform/sell-device-leads`,

  platformSellDeviceLeadSummary: `${Config.site_api}/v1/admin/platform/sell-device-leads/summary`,

  platformSellDeviceLeadFilters: `${Config.site_api}/v1/admin/platform/sell-device-leads/filters`,

  platformSellDeviceLeadById: (id) =>
    `${Config.site_api}/v1/admin/platform/sell-device-leads/${id}`,

  platformSellDeviceLeadStatus: (id) =>
    `${Config.site_api}/v1/admin/platform/sell-device-leads/${id}/status`,

  platformSellDeviceLeadAssign: (id) =>
    `${Config.site_api}/v1/admin/platform/sell-device-leads/${id}/assign`,

  platformSellDeviceLeadNotes: (id) =>
    `${Config.site_api}/v1/admin/platform/sell-device-leads/${id}/notes`,

  platformSellDeviceLeadOffer: (id) =>
    `${Config.site_api}/v1/admin/platform/sell-device-leads/${id}/offer`,

  // PLATFORM SUPPORT
  platformSupportTickets: `${Config.site_api}/v1/admin/platform/support-tickets`,

  platformSupportSummary: `${Config.site_api}/v1/admin/platform/support-tickets/summary`,

  platformSupportFilters: `${Config.site_api}/v1/admin/platform/support-tickets/filters`,

  platformSupportById: (id) =>
    `${Config.site_api}/v1/admin/platform/support-tickets/${id}`,

  platformSupportStatus: (id) =>
    `${Config.site_api}/v1/admin/platform/support-tickets/${id}/status`,

  platformSupportPriority: (id) =>
    `${Config.site_api}/v1/admin/platform/support-tickets/${id}/priority`,

  platformSupportNotes: (id) =>
    `${Config.site_api}/v1/admin/platform/support-tickets/${id}/notes`,

  platformSupportResolution: (id) =>
    `${Config.site_api}/v1/admin/platform/support-tickets/${id}/resolution`,

  /*
|--------------------------------------------------------------------------
| TENANT ROLE MANAGEMENT
|--------------------------------------------------------------------------
*/

  getRoles: `${Config.site_api}/v1/admin/roles`,

  createRole: `${Config.site_api}/v1/admin/roles`,

  getRoleById: (id) => `${Config.site_api}/v1/admin/roles/${id}`,

  updateRole: (id) => `${Config.site_api}/v1/admin/roles/${id}`,

  deleteRole: (id) => `${Config.site_api}/v1/admin/roles/${id}`,

  getRolePermissionCatalog: `${Config.site_api}/v1/admin/roles/permissions`,

  getRoleDropdown: `${Config.site_api}/v1/admin/roles/dropdown`,
  /*
|--------------------------------------------------------------------------
| TENANT SUBSCRIPTION
|--------------------------------------------------------------------------
*/

  getCurrentTenantSubscription: `${Config.site_api}/v1/admin/subscription/current`,

  getTenantSubscriptionPlans: `${Config.site_api}/v1/admin/subscription/plans`,

  selectTenantSubscriptionPlan: `${Config.site_api}/v1/admin/subscription/select-plan`,

  /*
|--------------------------------------------------------------------------
| TENANT SUBSCRIPTION PAYMENT
|--------------------------------------------------------------------------
*/

  createTenantSubscriptionPaymentOrder: `${Config.site_api}/v1/admin/subscription/payment/create-order`,

  verifyTenantSubscriptionPayment: `${Config.site_api}/v1/admin/subscription/payment/verify`,

  // TENANT MENU ROUTE
  tenantNavigationMenu: `${Config.site_api}/v1/admin/navigation/menu`,

  // admin route
  login: `${Config.site_api}/v1/admin/auth/login`,

  tenantLogin: `${Config.site_api}/v1/admin/auth/tenant-login`,

  getTenantProfile: `${Config.site_api}/v1/admin/auth/me`,

  updateTenantProfile: `${Config.site_api}/v1/admin/auth/profile`,
  updateTenantBusinessProfile: `${Config.site_api}/v1/admin/auth/business-profile`,
  changeTenantPassword: `${Config.site_api}/v1/admin/auth/change-password`,
  updateTenantBasicSettings: `${Config.site_api}/v1/admin/auth/basic-settings`,

  // INVOICE TEMPLATE / BRANDING
  updateTenantInvoiceTemplate: `${Config.site_api}/v1/admin/auth/invoice-template`,
  updateTenantInvoiceBranding: `${Config.site_api}/v1/admin/auth/invoice-branding`,

  // STOCK

  getAllStocks: `${Config.site_api}/v1/stock/get-all-stocks`,
  // Customer management
  createCustomer: `${Config.site_api}/v1/create-customer`,

  getCustomers: `${Config.site_api}/v1/customer/get-customers`,

  updateCustomerById: `${Config.site_api}/v1/customer/update-customer`,

  deleteCustomerById: (id) =>
    `${Config.site_api}/v1/customer/delete-customer/${id}`,

  changeCustomerStatusById: (id) =>
    `${Config.site_api}/v1/customer/change-status/${id}`,

  // Customer requirement management
  createCustomerRequirment: `${Config.site_api}/v1/create-customer-requirement`,

  getRequirements: `${Config.site_api}/v1/requirements/get-requirements`,

  getRequirementById: (id) => `${Config.site_api}/v1/requirement/${id}`,

  updateRequirementById: `${Config.site_api}/v1/requirement/update-requirement`,

  changeRequirementStatus: (id) =>
    `${Config.site_api}/v1/requirement/change-status/${id}`,

  deleteRequirementById: (id) =>
    `${Config.site_api}/v1/requirement/delete-requirement/${id}`,

  /* =========================================================
   CUSTOMER ORDER MANAGEMENT
========================================================= */

  getOrders: `${Config.site_api}/v1/admin/order-management/orders`,

  getOrderById: (id) =>
    `${Config.site_api}/v1/admin/order-management/orders/${id}`,

  acceptOrder: (id) =>
    `${Config.site_api}/v1/admin/order-management/orders/${id}/accept`,

  updateOrderStatus: (id) =>
    `${Config.site_api}/v1/admin/order-management/orders/${id}/status`,

  updateOrderTracking: (id) =>
    `${Config.site_api}/v1/admin/order-management/orders/${id}/tracking`,

  shipOrder: (id) =>
    `${Config.site_api}/v1/admin/order-management/orders/${id}/ship`,

  cancelOrder: (id) =>
    `${Config.site_api}/v1/admin/order-management/orders/${id}/cancel`,

  returnOrder: (id) =>
    `${Config.site_api}/v1/admin/order-management/orders/${id}/return`,

  updateOrderNotes: (id) =>
    `${Config.site_api}/v1/admin/order-management/orders/${id}/notes`,

  // Inventory Category Management

  createInventoryCategory: `${Config.site_api}/v1/admin/inventory/categories/create`,

  getInventoryCategories: `${Config.site_api}/v1/admin/inventory/categories/list`,

  getInventoryCategoryDropdown: `${Config.site_api}/v1/admin/inventory/categories/dropdown`,

  getInventoryCategoryById: (id) =>
    `${Config.site_api}/v1/admin/inventory/categories/${id}`,

  updateInventoryCategory: `${Config.site_api}/v1/admin/inventory/categories/update`,

  changeInventoryCategoryStatus: (id) =>
    `${Config.site_api}/v1/admin/inventory/categories/${id}/status`,

  deleteInventoryCategory: (id) =>
    `${Config.site_api}/v1/admin/inventory/categories/${id}`,

  /*
    |--------------------------------------------------------------------------
    | Inventory Product Management
    |--------------------------------------------------------------------------
    */

  createInventoryProduct: `${Config.site_api}/v1/admin/inventory/products/create`,

  getInventoryProducts: `${Config.site_api}/v1/admin/inventory/products/list`,

  getInventoryProductsClient: `${Config.site_api}/v1/admin/inventory/products/client`,

  getInventoryProductById: (id) =>
    `${Config.site_api}/v1/admin/inventory/products/${id}`,

  updateInventoryProduct: `${Config.site_api}/v1/admin/inventory/products/update`,

  changeInventoryProductStatus: (id) =>
    `${Config.site_api}/v1/admin/inventory/products/${id}/status`,

  uploadInventoryProductImages: (id) =>
    `${Config.site_api}/v1/admin/inventory/products/${id}/images`,

  removeInventoryProductImage: (id) =>
    `${Config.site_api}/v1/admin/inventory/products/${id}/images`,

  deleteInventoryProduct: (id) =>
    `${Config.site_api}/v1/admin/inventory/products/${id}`,

  /*
    |--------------------------------------------------------------------------
    | Inventory Stock Management
    |--------------------------------------------------------------------------
    */

  adjustInventoryStock: `${Config.site_api}/v1/admin/inventory/stock/adjust`,

  reconcileInventoryStock: `${Config.site_api}/v1/admin/inventory/stock/reconcile`,

  reserveInventoryStock: `${Config.site_api}/v1/admin/inventory/stock/reserve`,

  releaseReservedInventoryStock: `${Config.site_api}/v1/admin/inventory/stock/release-reserved`,

  completeInventorySale: `${Config.site_api}/v1/admin/inventory/stock/complete-sale`,

  getInventoryStockMovements: `${Config.site_api}/v1/admin/inventory/stock/movements`,

  getInventoryProductStockSummary: (id) =>
    `${Config.site_api}/v1/admin/inventory/stock/product/${id}`,

  getLowStockInventoryProducts: `${Config.site_api}/v1/admin/inventory/stock/low-stock`,

  getInventorySummary: `${Config.site_api}/v1/admin/inventory/stock/summary`,

  /*
    |--------------------------------------------------------------------------
    | WEBSITE CUSTOMER MANAGEMENT - SIGNUP USER ON WEBSITE
    |--------------------------------------------------------------------------
    */
  createUser: `${Config.site_api}/v1/platform/users/create-user`,

  getUsers: `${Config.site_api}/v1/platform/users/get-all-users`,

  getUserById: (id) => `${Config.site_api}/v1/platform/users/get-user/${id}`,

  updateUser: (id) => `${Config.site_api}/v1/platform/users/update-user/${id}`,

  changeUserStatus: (id) =>
    `${Config.site_api}/v1/platform/users/change-user-status/${id}`,

  deleteUser: (id) => `${Config.site_api}/v1/platform/users/delete-user/${id}`,

  // EMPLOYEE MANAGEMENT

  employeeDropdownData: `${Config.site_api}/v1/admin/employees/dropdown-data`,

  createEmployee: `${Config.site_api}/v1/admin/employees/create`,

  getEmployees: `${Config.site_api}/v1/admin/employees/list`,

  getEmployeeById: (id) => `${Config.site_api}/v1/admin/employees/${id}`,

  updateEmployee: (id) => `${Config.site_api}/v1/admin/employees/${id}`,

  changeEmployeeStatus: (id) =>
    `${Config.site_api}/v1/admin/employees/${id}/status`,

  toggleEmployeeLoginAccess: (id) =>
    `${Config.site_api}/v1/admin/employees/${id}/login-access`,

  deleteEmployee: (id) => `${Config.site_api}/v1/admin/employees/${id}`,

  // TASK MANAGEMENT

  createTask: `${Config.site_api}/v1/admin/tasks/create`,

  getRequirementTasks: (requirementId) =>
    `${Config.site_api}/v1/admin/tasks/requirement/${requirementId}`,

  getTaskEmployeeDropdown: `${Config.site_api}/v1/admin/tasks/employee-dropdown`,

  getTaskDropdownData: `${Config.site_api}/v1/admin/tasks/dropdown-data`,

  getTaskDetails: (taskId) =>
    `${Config.site_api}/v1/admin/tasks/details/${taskId}`,

  markTaskRead: (taskId) =>
    `${Config.site_api}/v1/admin/tasks/mark-read/${taskId}`,

  addTaskComment: (taskId) =>
    `${Config.site_api}/v1/admin/tasks/add-comment/${taskId}`,

  updateTask: (taskId) => `${Config.site_api}/v1/admin/tasks/update/${taskId}`,

  getTaskList: `${Config.site_api}/v1/admin/tasks/list`,

  getTaskSummary: `${Config.site_api}/v1/admin/tasks/summary`,

  deleteTask: (taskId) => `${Config.site_api}/v1/admin/tasks/delete/${taskId}`,

  changeTaskStatus: (taskId) =>
    `${Config.site_api}/v1/admin/tasks/change-status/${taskId}`,

  // getRequirementTaskPreview: (requirementId) =>
  //   `${Config.site_api}/v1/admin/tasks/requirement/${requirementId}/preview`,

  // getTaskComments: (taskId) =>
  //   `${Config.site_api}/v1/admin/tasks/comments/${taskId}`,

  // deleteTaskComment: (commentId) =>
  //   `${Config.site_api}/v1/admin/tasks/comment/${commentId}`,

  // updateTaskComment: (commentId) =>
  //   `${Config.site_api}/v1/admin/tasks/comment/${commentId}`,
  // BILLING MODULE API ENDPOINT
  /*
    |--------------------------------------------------------------------------
    | BILLING HEALTH
    |--------------------------------------------------------------------------
    */

  billingHealth: `${billingBaseUrl}/health`,

  /*
        |--------------------------------------------------------------------------
        | BILLING SETTINGS
        |--------------------------------------------------------------------------
        */

  getBillingSettings: `${billingBaseUrl}/settings`,

  updateBillingSettings: `${billingBaseUrl}/settings`,

  getBillingSettingsDropdowns: `${billingBaseUrl}/settings/dropdowns`,

  uploadBillingLogo: `${billingBaseUrl}/settings/logo`,

  uploadBillingSignature: `${billingBaseUrl}/settings/signature`,

  /*
        |--------------------------------------------------------------------------
        | INVOICE SERIES
        |--------------------------------------------------------------------------
        */

  getInvoiceSeries: `${billingBaseUrl}/invoice-series`,

  createInvoiceSeries: `${billingBaseUrl}/invoice-series`,

  getInvoiceSeriesDropdowns: `${billingBaseUrl}/invoice-series/dropdowns`,

  getInvoiceSeriesSummary: `${billingBaseUrl}/invoice-series/summary`,

  getInvoiceSeriesCreateData: `${billingBaseUrl}/invoice-series/create-data`,

  getNextInvoiceNumber: `${billingBaseUrl}/invoice-series/next-number`,

  validateInvoiceSeries: `${billingBaseUrl}/invoice-series/validate`,

  getInvoiceSeriesById: (id) => `${billingBaseUrl}/invoice-series/${id}`,

  updateInvoiceSeries: (id) => `${billingBaseUrl}/invoice-series/${id}`,

  activateInvoiceSeries: (id) =>
    `${billingBaseUrl}/invoice-series/${id}/activate`,

  deactivateInvoiceSeries: (id) =>
    `${billingBaseUrl}/invoice-series/${id}/deactivate`,

  setDefaultInvoiceSeries: (id) =>
    `${billingBaseUrl}/invoice-series/${id}/default`,

  deleteInvoiceSeries: (id) => `${billingBaseUrl}/invoice-series/${id}`,

  /*
        |--------------------------------------------------------------------------
        | SALE INVOICES
        |--------------------------------------------------------------------------
        */

  getSaleInvoices: `${billingBaseUrl}/sale-invoices`,

  createSaleInvoice: `${billingBaseUrl}/sale-invoices`,

  getSaleInvoiceSummary: `${billingBaseUrl}/sale-invoices/summary`,

  getSaleInvoiceCreateData: `${billingBaseUrl}/sale-invoices/create-data`,

  getSaleInvoiceDropdowns: `${billingBaseUrl}/sale-invoices/dropdowns`,

  getSaleInvoiceById: (id) => `${billingBaseUrl}/sale-invoices/${id}`,

  updateSaleInvoice: (id) => `${billingBaseUrl}/sale-invoices/${id}`,

  confirmSaleInvoice: (id) => `${billingBaseUrl}/sale-invoices/${id}/confirm`,

  cancelSaleInvoice: (id) => `${billingBaseUrl}/sale-invoices/${id}/cancel`,

  duplicateSaleInvoice: (id) =>
    `${billingBaseUrl}/sale-invoices/${id}/duplicate`,

  deleteSaleInvoice: (id) => `${billingBaseUrl}/sale-invoices/${id}`,

  getSaleInvoiceHistory: (id) =>
    `${billingBaseUrl}/sale-invoices/${id}/history`,

  /*
        |--------------------------------------------------------------------------
        | QUOTATIONS
        |--------------------------------------------------------------------------
        */

  getQuotations: `${billingBaseUrl}/quotations`,

  createQuotation: `${billingBaseUrl}/quotations`,

  getQuotationSummary: `${billingBaseUrl}/quotations/summary`,

  getQuotationCreateData: `${billingBaseUrl}/quotations/create-data`,

  getQuotationDropdowns: `${billingBaseUrl}/quotations/dropdowns`,

  getQuotationById: (id) => `${billingBaseUrl}/quotations/${id}`,

  updateQuotation: (id) => `${billingBaseUrl}/quotations/${id}`,

  confirmQuotation: (id) => `${billingBaseUrl}/quotations/${id}/confirm`,

  cancelQuotation: (id) => `${billingBaseUrl}/quotations/${id}/cancel`,

  duplicateQuotation: (id) => `${billingBaseUrl}/quotations/${id}/duplicate`,

  convertQuotation: (id) => `${billingBaseUrl}/quotations/${id}/convert`,

  deleteQuotation: (id) => `${billingBaseUrl}/quotations/${id}`,

  getQuotationHistory: (id) => `${billingBaseUrl}/quotations/${id}/history`,

  /*
        |--------------------------------------------------------------------------
        | PROFORMA INVOICES
        |--------------------------------------------------------------------------
        */

  getProformaInvoices: `${billingBaseUrl}/proforma-invoices`,

  createProformaInvoice: `${billingBaseUrl}/proforma-invoices`,

  getProformaInvoiceSummary: `${billingBaseUrl}/proforma-invoices/summary`,

  getProformaInvoiceCreateData: `${billingBaseUrl}/proforma-invoices/create-data`,

  getProformaInvoiceDropdowns: `${billingBaseUrl}/proforma-invoices/dropdowns`,

  getProformaInvoiceById: (id) => `${billingBaseUrl}/proforma-invoices/${id}`,

  updateProformaInvoice: (id) => `${billingBaseUrl}/proforma-invoices/${id}`,

  confirmProformaInvoice: (id) =>
    `${billingBaseUrl}/proforma-invoices/${id}/confirm`,

  cancelProformaInvoice: (id) =>
    `${billingBaseUrl}/proforma-invoices/${id}/cancel`,

  duplicateProformaInvoice: (id) =>
    `${billingBaseUrl}/proforma-invoices/${id}/duplicate`,

  convertProformaInvoice: (id) =>
    `${billingBaseUrl}/proforma-invoices/${id}/convert`,

  deleteProformaInvoice: (id) => `${billingBaseUrl}/proforma-invoices/${id}`,

  getProformaInvoiceHistory: (id) =>
    `${billingBaseUrl}/proforma-invoices/${id}/history`,

  /*
        |--------------------------------------------------------------------------
        | SALE ORDERS
        |--------------------------------------------------------------------------
        */

  getSaleOrders: `${billingBaseUrl}/sale-orders`,

  createSaleOrder: `${billingBaseUrl}/sale-orders`,

  getSaleOrderSummary: `${billingBaseUrl}/sale-orders/summary`,

  getSaleOrderCreateData: `${billingBaseUrl}/sale-orders/create-data`,

  getSaleOrderDropdowns: `${billingBaseUrl}/sale-orders/dropdowns`,

  getSaleOrderById: (id) => `${billingBaseUrl}/sale-orders/${id}`,

  updateSaleOrder: (id) => `${billingBaseUrl}/sale-orders/${id}`,

  confirmSaleOrder: (id) => `${billingBaseUrl}/sale-orders/${id}/confirm`,

  cancelSaleOrder: (id) => `${billingBaseUrl}/sale-orders/${id}/cancel`,

  duplicateSaleOrder: (id) => `${billingBaseUrl}/sale-orders/${id}/duplicate`,

  convertSaleOrder: (id) => `${billingBaseUrl}/sale-orders/${id}/convert`,

  deleteSaleOrder: (id) => `${billingBaseUrl}/sale-orders/${id}`,

  getSaleOrderHistory: (id) => `${billingBaseUrl}/sale-orders/${id}/history`,

  /*
        |--------------------------------------------------------------------------
        | DELIVERY CHALLANS
        |--------------------------------------------------------------------------
        */

  getDeliveryChallans: `${billingBaseUrl}/delivery-challans`,

  createDeliveryChallan: `${billingBaseUrl}/delivery-challans`,

  getDeliveryChallanSummary: `${billingBaseUrl}/delivery-challans/summary`,

  getDeliveryChallanCreateData: `${billingBaseUrl}/delivery-challans/create-data`,

  getDeliveryChallanDropdowns: `${billingBaseUrl}/delivery-challans/dropdowns`,

  getDeliveryChallanById: (id) => `${billingBaseUrl}/delivery-challans/${id}`,

  updateDeliveryChallan: (id) => `${billingBaseUrl}/delivery-challans/${id}`,

  confirmDeliveryChallan: (id) =>
    `${billingBaseUrl}/delivery-challans/${id}/confirm`,

  cancelDeliveryChallan: (id) =>
    `${billingBaseUrl}/delivery-challans/${id}/cancel`,

  duplicateDeliveryChallan: (id) =>
    `${billingBaseUrl}/delivery-challans/${id}/duplicate`,

  convertDeliveryChallan: (id) =>
    `${billingBaseUrl}/delivery-challans/${id}/convert`,

  deleteDeliveryChallan: (id) => `${billingBaseUrl}/delivery-challans/${id}`,

  getDeliveryChallanHistory: (id) =>
    `${billingBaseUrl}/delivery-challans/${id}/history`,

  /*
        |--------------------------------------------------------------------------
        | PAYMENT IN
        |--------------------------------------------------------------------------
        */

  getBillingPayments: `${billingBaseUrl}/payments`,

  createBillingPayment: `${billingBaseUrl}/payments`,

  getBillingPaymentSummary: `${billingBaseUrl}/payments/summary`,

  getBillingPaymentCreateData: `${billingBaseUrl}/payments/create-data`,

  getBillingPaymentDropdowns: `${billingBaseUrl}/payments/dropdowns`,

  getBillingPaymentById: (id) => `${billingBaseUrl}/payments/${id}`,

  updateBillingPayment: (id) => `${billingBaseUrl}/payments/${id}`,

  cancelBillingPayment: (id) => `${billingBaseUrl}/payments/${id}/cancel`,

  deleteBillingPayment: (id) => `${billingBaseUrl}/payments/${id}`,

  getCustomerOutstandingInvoices: (customerId) =>
    `${billingBaseUrl}/payments/customers/${customerId}/outstanding`,

  /*
        |--------------------------------------------------------------------------
        | SALE RETURNS
        |--------------------------------------------------------------------------
        */

  getSaleReturns: `${billingBaseUrl}/sale-returns`,

  createSaleReturn: `${billingBaseUrl}/sale-returns`,

  getSaleReturnSummary: `${billingBaseUrl}/sale-returns/summary`,

  getSaleReturnCreateData: `${billingBaseUrl}/sale-returns/create-data`,

  getSaleReturnDropdowns: `${billingBaseUrl}/sale-returns/dropdowns`,

  getReturnableInvoice: (invoiceId) =>
    `${billingBaseUrl}/sale-returns/invoices/${invoiceId}`,

  getReturnableInvoiceItems: (invoiceId) =>
    `${billingBaseUrl}/sale-returns/invoices/${invoiceId}/items`,

  getSaleReturnById: (id) => `${billingBaseUrl}/sale-returns/${id}`,

  confirmSaleReturn: (id) => `${billingBaseUrl}/sale-returns/${id}/confirm`,

  cancelSaleReturn: (id) => `${billingBaseUrl}/sale-returns/${id}/cancel`,

  deleteSaleReturn: (id) => `${billingBaseUrl}/sale-returns/${id}`,

  getSaleReturnHistory: (id) => `${billingBaseUrl}/sale-returns/${id}/history`,

  /*
        |--------------------------------------------------------------------------
        | BILLING CUSTOMER AND PRODUCT SEARCH
        |--------------------------------------------------------------------------
        */

  searchBillingCustomers: `${billingBaseUrl}/customers/search`,

  getBillingCustomerById: (id) => `${billingBaseUrl}/customers/${id}`,

  searchBillingProducts: `${billingBaseUrl}/products/search`,

  getBillingProductById: (id) => `${billingBaseUrl}/products/${id}`,

  /*
        |--------------------------------------------------------------------------
        | BILLING CALCULATION
        |--------------------------------------------------------------------------
        */

  calculateBillingDocument: `${billingBaseUrl}/calculation/document`,

  calculateBillingItem: `${billingBaseUrl}/calculation/item`,

  getBillingCalculationDropdowns: `${billingBaseUrl}/calculation/dropdowns`,

  /*
        |--------------------------------------------------------------------------
        | BILLING IMPORT
        |--------------------------------------------------------------------------
        */

  uploadBillingImport: `${billingBaseUrl}/imports/upload`,

  getBillingImports: `${billingBaseUrl}/imports`,

  getBillingImportDropdowns: `${billingBaseUrl}/imports/dropdowns`,

  getBillingImportById: (id) => `${billingBaseUrl}/imports/${id}`,

  saveBillingImportMapping: (id) => `${billingBaseUrl}/imports/${id}/mapping`,

  previewBillingImport: (id) => `${billingBaseUrl}/imports/${id}/preview`,

  executeBillingImport: (id) => `${billingBaseUrl}/imports/${id}/execute`,

  getBillingImportRows: (id) => `${billingBaseUrl}/imports/${id}/rows`,

  cancelBillingImport: (id) => `${billingBaseUrl}/imports/${id}/cancel`,

  deleteBillingImport: (id) => `${billingBaseUrl}/imports/${id}`,

  /*
        |--------------------------------------------------------------------------
        | BILLING PDF
        |--------------------------------------------------------------------------
        */

  generateBillingDocumentPdf: (id) =>
    `${billingBaseUrl}/pdf/documents/${id}/generate`,

  viewBillingDocumentPdf: (id) => `${billingBaseUrl}/pdf/documents/${id}/view`,

  downloadBillingDocumentPdf: (id) =>
    `${billingBaseUrl}/pdf/documents/${id}/download`,

  printBillingDocumentPdf: (id) =>
    `${billingBaseUrl}/pdf/documents/${id}/print`,

  getBillingDocumentPdfInfo: (id) => `${billingBaseUrl}/pdf/documents/${id}`,

  generatePaymentReceiptPdf: (id) =>
    `${billingBaseUrl}/pdf/payments/${id}/generate`,

  viewPaymentReceiptPdf: (id) => `${billingBaseUrl}/pdf/payments/${id}/view`,

  downloadPaymentReceiptPdf: (id) =>
    `${billingBaseUrl}/pdf/payments/${id}/download`,

  getPaymentReceiptPdfInfo: (id) => `${billingBaseUrl}/pdf/payments/${id}`,

  /*
        |--------------------------------------------------------------------------
        | BILLING SHARE
        |--------------------------------------------------------------------------
        */

  getBillingShareDropdowns: `${billingBaseUrl}/share/dropdowns`,

  prepareBillingDocumentShare: (id) =>
    `${billingBaseUrl}/share/documents/${id}`,

  shareBillingDocumentWhatsApp: (id) =>
    `${billingBaseUrl}/share/documents/${id}/whatsapp`,

  shareBillingDocumentEmail: (id) =>
    `${billingBaseUrl}/share/documents/${id}/email`,

  copyBillingDocumentLink: (id) =>
    `${billingBaseUrl}/share/documents/${id}/copy-link`,

  preparePaymentReceiptShare: (id) => `${billingBaseUrl}/share/payments/${id}`,

  sharePaymentReceiptWhatsApp: (id) =>
    `${billingBaseUrl}/share/payments/${id}/whatsapp`,

  sharePaymentReceiptEmail: (id) =>
    `${billingBaseUrl}/share/payments/${id}/email`,

  copyPaymentReceiptLink: (id) =>
    `${billingBaseUrl}/share/payments/${id}/copy-link`,

  /*
        |--------------------------------------------------------------------------
        | BILLING HISTORY
        |--------------------------------------------------------------------------
        */

  getBillingActivity: `${billingBaseUrl}/history`,

  getBillingHistoryDropdowns: `${billingBaseUrl}/history/dropdowns`,

  getBillingDocumentHistory: (id) =>
    `${billingBaseUrl}/history/documents/${id}`,

  getBillingDocumentTimeline: (id) =>
    `${billingBaseUrl}/history/documents/${id}/timeline`,

  addBillingDocumentNote: (id) =>
    `${billingBaseUrl}/history/documents/${id}/note`,

  getBillingPaymentHistory: (id) => `${billingBaseUrl}/history/payments/${id}`,

  getBillingPaymentTimeline: (id) =>
    `${billingBaseUrl}/history/payments/${id}/timeline`,

  /*
        |--------------------------------------------------------------------------
        | BILLING REPORTS
        |--------------------------------------------------------------------------
        */

  getBillingReportDropdowns: `${billingBaseUrl}/reports/dropdowns`,

  getSalesOverviewReport: `${billingBaseUrl}/reports/sales-overview`,

  getSalesTrendReport: `${billingBaseUrl}/reports/sales-trend`,

  getSalesChannelReport: `${billingBaseUrl}/reports/sales-channel`,

  getOutstandingSalesReport: `${billingBaseUrl}/reports/outstanding-sales`,

  getCustomerSalesReport: `${billingBaseUrl}/reports/customer-sales`,

  getProductSalesReport: `${billingBaseUrl}/reports/product-sales`,

  getPaymentMethodReport: `${billingBaseUrl}/reports/payment-methods`,

  getTaxSummaryReport: `${billingBaseUrl}/reports/tax-summary`,

  getSaleReturnReport: `${billingBaseUrl}/reports/sale-returns`,

  getDocumentTypeReport: `${billingBaseUrl}/reports/document-types`,
  getSaleInvoicePaymentHistory: (invoiceId) =>
    `${billingBaseUrl}/sale-invoice-payments/${invoiceId}`,

  getSaleInvoicePaymentById: (invoiceId, allocationId) =>
    `${billingBaseUrl}/sale-invoice-payments/${invoiceId}/${allocationId}`,

  reverseBillingPayment: (paymentId) =>
    `${billingBaseUrl}/payments/${paymentId}/reverse`,

  getSaleInvoiceStockMovements: (invoiceId) =>
    `${billingBaseUrl}/sale-invoices/${invoiceId}/stock-movements`,
  retrySaleInvoiceStockPosting: (invoiceId) =>
    `${billingBaseUrl}/sale-invoices/${invoiceId}/retry-stock-posting`,

  getCustomerLedger: () => `${billingBaseUrl}/customer-ledger`,

  getCustomerLedgerByCustomer: (customerId) =>
    `${billingBaseUrl}/customer-ledger/customer/${customerId}`,

  getCustomerLedgerByMobile: (mobile) =>
    `${billingBaseUrl}/customer-ledger/mobile/${mobile}`,
  getCustomerOutstandingInvoices: (customerId) =>
    `${billingBaseUrl}/payment-allocations/customers/${customerId}/outstanding`,

  allocateExistingPayment: (paymentId) =>
    `${billingBaseUrl}/payment-allocations/payments/${paymentId}/allocate`,

  getPaymentAllocations: (paymentId) =>
    `${billingBaseUrl}/payment-allocations/payments/${paymentId}`,

  reversePaymentAllocation: (allocationId) =>
    `${billingBaseUrl}/payment-allocations/${allocationId}/reverse`,

  getAllCustomerLedger: () => `${billingBaseUrl}/customer-ledger/all`,
  // CREDIT NOTE MODULE API ENDPOINT

  createCreditNote: () => `${billingBaseUrl}/credit-notes`,

  getCreditNotes: () => `${billingBaseUrl}/credit-notes`,

  getCreditNotesByInvoice: (invoiceId) =>
    `${billingBaseUrl}/credit-notes/invoice/${invoiceId}`,

  getCreditNoteById: (creditNoteId) =>
    `${billingBaseUrl}/credit-notes/${creditNoteId}`,

  confirmCreditNote: (creditNoteId) =>
    `${billingBaseUrl}/credit-notes/${creditNoteId}/confirm`,

  cancelCreditNote: (creditNoteId) =>
    `${billingBaseUrl}/credit-notes/${creditNoteId}/cancel`,

  getCustomerLedgerSummary: () => `${billingBaseUrl}/customer-ledger/customers`,

  applyCreditNote: (creditNoteId) =>
    `${billingBaseUrl}/credit-notes/${creditNoteId}/apply`,

  createDebitNote: () => `${billingBaseUrl}/debit-notes`,

  getDebitNotes: () => `${billingBaseUrl}/debit-notes`,

  getDebitNoteById: (debitNoteId) =>
    `${billingBaseUrl}/debit-notes/${debitNoteId}`,

  getDebitNotesByPurchaseBill: (purchaseBillId) =>
    `${billingBaseUrl}/debit-notes/purchase-bill/${purchaseBillId}`,

  confirmDebitNote: (debitNoteId) =>
    `${billingBaseUrl}/debit-notes/${debitNoteId}/confirm`,

  cancelDebitNote: (debitNoteId) =>
    `${billingBaseUrl}/debit-notes/${debitNoteId}/cancel`,

  // /credit-notes/:creditNoteId/apply

  /*
    |--------------------------------------------------------------------------
    | SUPPLIER LEDGER
    |--------------------------------------------------------------------------
    */

  getSupplierLedgerEntries: () => `${billingBaseUrl}/supplier-ledger/all`,

  getSupplierLedgerSummary: () => `${billingBaseUrl}/supplier-ledger/summary`,

  getSupplierBalanceList: () => `${billingBaseUrl}/supplier-ledger/suppliers`,

  getSupplierLedgerBySupplier: (supplierId) =>
    `${billingBaseUrl}/supplier-ledger/supplier/${supplierId}`,

  getSupplierLedgerEntryById: (ledgerEntryId) =>
    `${billingBaseUrl}/supplier-ledger/${ledgerEntryId}`,

  recalculateSupplierLedger: (supplierId) =>
    `${billingBaseUrl}/supplier-ledger/supplier/${supplierId}/recalculate`,

  // --------------------------------------------------------------------------
  // PAYMENT OUT / SUPPLIER PAYMENTS
  // --------------------------------------------------------------------------

  createPaymentOut: () => `${billingBaseUrl}/payment-out`,

  getPaymentOutList: () => `${billingBaseUrl}/payment-out`,

  getPaymentOutById: (paymentOutId) =>
    `${billingBaseUrl}/payment-out/${paymentOutId}`,

  getSupplierOutstandingPurchaseBills: (supplierId) =>
    `${billingBaseUrl}/payment-out/supplier/${supplierId}/outstanding-bills`,

  /*
        |--------------------------------------------------------------------------
        | PURCHASE BILLS
        |--------------------------------------------------------------------------
        */

  createPurchaseBill: () => `${billingBaseUrl}/purchase-bills`,

  getPurchaseBillList: () => `${billingBaseUrl}/purchase-bills`,

  getPurchaseBillById: (purchaseBillId) =>
    `${billingBaseUrl}/purchase-bills/${purchaseBillId}`,

  updatePurchaseBill: (purchaseBillId) =>
    `${billingBaseUrl}/purchase-bills/${purchaseBillId}`,

  confirmPurchaseBill: (purchaseBillId) =>
    `${billingBaseUrl}/purchase-bills/${purchaseBillId}/confirm`,

  refreshPurchaseBillBalance: (purchaseBillId) =>
    `${billingBaseUrl}/purchase-bills/${purchaseBillId}/refresh-balance`,
  // ============================================================
  // SUPPLIER MASTER
  // ============================================================

  getSuppliers: `${billingBaseUrl}/suppliers`,

  getActiveSuppliers: `${billingBaseUrl}/suppliers/active`,

  getSupplierById: `${billingBaseUrl}/suppliers`,

  createSupplier: `${billingBaseUrl}/suppliers`,

  updateSupplier: `${billingBaseUrl}/suppliers`,

  toggleSupplierStatus: `${billingBaseUrl}/suppliers`,

  updateSupplierStatus: `${billingBaseUrl}/suppliers`,

  deleteSupplier: `${billingBaseUrl}/suppliers`,

  cancelPurchaseBill: `${billingBaseUrl}/purchase-bills`,

  reversePaymentOut: (paymentOutId) =>
    `${billingBaseUrl}/payment-out/${paymentOutId}/reverse`,

  getSupplierPayables: () => `${billingBaseUrl}/supplier-payables`,

  getSupplierPayableDetails: (supplierId) =>
    `${billingBaseUrl}/supplier-payables/${supplierId}`,

  getSupplierPayableBills: (supplierId) =>
    `${billingBaseUrl}/supplier-payables/${supplierId}/bills`,

  getSupplierPayableAgeingSummary: () =>
    `${billingBaseUrl}/supplier-payables/ageing-summary`,

  getSupplierPayableLedgerBalance: (supplierId) =>
    `${billingBaseUrl}/supplier-payables/${supplierId}/ledger-balance`,

  purchaseRegister: () =>
    `${billingBaseUrl}/v1/admin/billing/purchase-reports/register`,

  purchaseRegisterSummary: () =>
    `${billingBaseUrl}/v1/admin/billing/purchase-reports/register/summary`,

  /*
        |--------------------------------------------------------------------------
        | PURCHASE REPORTS
        |--------------------------------------------------------------------------
        */

  getPurchaseRegister: () => `${billingBaseUrl}/purchase-reports/register`,

  getPurchaseRegisterSummary: () =>
    `${billingBaseUrl}/purchase-reports/register/summary`,

  getSupplierPurchaseSummary: () =>
    `${billingBaseUrl}/purchase-reports/supplier-summary`,

  getPurchaseDebitNoteReport: () =>
    `${billingBaseUrl}/purchase-reports/debit-notes`,

  getPurchasePaymentOutReport: () =>
    `${billingBaseUrl}/purchase-reports/payment-out`,

  getPurchaseOutstandingReport: () =>
    `${billingBaseUrl}/purchase-reports/outstanding`,

  getPurchaseAgeingReport: () => `${billingBaseUrl}/purchase-reports/ageing`,

  getPurchaseGstInputReport: () =>
    `${billingBaseUrl}/purchase-reports/gst-input`,

  /*
    |--------------------------------------------------------------------------
    | GST REPORTS
    |--------------------------------------------------------------------------
    */

  getGstDashboard: () => `${billingBaseUrl}/gst/dashboard`,

  getPurchaseGstRegister: () => `${billingBaseUrl}/gst/purchase-register`,

  getSalesGstRegister: () => `${billingBaseUrl}/gst/sales-register`,

  getGstr1Report: () => `${billingBaseUrl}/gst/gstr1`,

  getGstr3bReport: () => `${billingBaseUrl}/gst/gstr3b`,
  getHsnSummaryReport: () => `${billingBaseUrl}/gst/hsn-summary`,
  getGstReconciliation: () => `${billingBaseUrl}/gst/reconciliation`,

  /*
    |--------------------------------------------------------------------------
    | FINAL GST FILING
    |--------------------------------------------------------------------------
    */

  validateGstFiling: () => `${billingBaseUrl}/gst/filing/validate`,

  exportGstReport: (reportType) => `${billingBaseUrl}/gst/export/${reportType}`,

  getGstReturnPeriods: () => `${billingBaseUrl}/gst/return-periods`,

  saveGstReturnPeriod: () => `${billingBaseUrl}/gst/return-periods`,

  validateGstReturnPeriod: (id) =>
    `${billingBaseUrl}/gst/return-periods/${id}/validate`,

  markGstReturnExported: (id) =>
    `${billingBaseUrl}/gst/return-periods/${id}/mark-exported`,

  markGstReturnFiled: (id) =>
    `${billingBaseUrl}/gst/return-periods/${id}/mark-filed`,

  lockGstReturnPeriod: (id) =>
    `${billingBaseUrl}/gst/return-periods/${id}/lock`,

  /*
            |--------------------------------------------------------------------------
            | ADMIN DASHBOARD
            |--------------------------------------------------------------------------
            */
  dashboardOverview: `${Config.site_api}/v1/admin/dashboard/overview`,

  /*
|--------------------------------------------------------------------------
| EMPLOYEE MASTER
|--------------------------------------------------------------------------
*/

  employeeDropdownData: `${Config.site_api}/v1/admin/employees/dropdown-data`,

  createEmployee: `${Config.site_api}/v1/admin/employees/create`,

  getEmployees: `${Config.site_api}/v1/admin/employees/list`,

  getEmployeeById: (id) => `${Config.site_api}/v1/admin/employees/${id}`,

  updateEmployee: (id) => `${Config.site_api}/v1/admin/employees/${id}`,

  changeEmployeeStatus: (id) =>
    `${Config.site_api}/v1/admin/employees/${id}/status`,

  toggleEmployeeLoginAccess: (id) =>
    `${Config.site_api}/v1/admin/employees/${id}/login-access`,

  deleteEmployee: (id) => `${Config.site_api}/v1/admin/employees/${id}`,

  /* EMPLOYEE OFFER & ONBOARDING */
  getEmployeeOfferDropdownData: `${Config.site_api}/v1/admin/employee-offers/dropdown-data`,
  getEmployeeOffers: `${Config.site_api}/v1/admin/employee-offers/list`,
  createEmployeeOffer: (employeeId) =>
    `${Config.site_api}/v1/admin/employee-offers/employee/${employeeId}`,
  getEmployeeOfferById: (id) =>
    `${Config.site_api}/v1/admin/employee-offers/${id}`,
  getEmployeeOfferLink: (id) =>
    `${Config.site_api}/v1/admin/employee-offers/${id}/link`,
  regenerateEmployeeOfferLink: (id) =>
    `${Config.site_api}/v1/admin/employee-offers/${id}/regenerate-link`,
  sendEmployeeOfferEmail: (id) =>
    `${Config.site_api}/v1/admin/employee-offers/${id}/send-email`,
  verifyEmployeeOffer: (id) =>
    `${Config.site_api}/v1/admin/employee-offers/${id}/verify`,
  sendEmployeeCredentials: (id) =>
    `${Config.site_api}/v1/admin/employee-offers/${id}/send-credentials`,
  cancelEmployeeOffer: (id) =>
    `${Config.site_api}/v1/admin/employee-offers/${id}/cancel`,

  publicEmployeeOffer: (token) =>
    `${Config.site_api}/v1/public/employee-offers/${token}`,
  acceptEmployeeOffer: (token) =>
    `${Config.site_api}/v1/public/employee-offers/${token}/accept`,
  rejectEmployeeOffer: (token) =>
    `${Config.site_api}/v1/public/employee-offers/${token}/reject`,
  submitEmployeeOnboarding: (token) =>
    `${Config.site_api}/v1/public/employee-offers/${token}/details`,

  /*
|--------------------------------------------------------------------------
| EMPLOYEE SALARY
|--------------------------------------------------------------------------
*/

  getEmployeeSalarySummary: `${Config.site_api}/v1/admin/employee-salary/summary`,

  generateEmployeeSalary: `${Config.site_api}/v1/admin/employee-salary/generate`,

  getEmployeeSalaries: `${Config.site_api}/v1/admin/employee-salary/list`,

  getEmployeeSalaryById: (id) =>
    `${Config.site_api}/v1/admin/employee-salary/${id}`,

  updateEmployeeSalary: (id) =>
    `${Config.site_api}/v1/admin/employee-salary/${id}`,

  getEmployeeSalaryPayments: (id) =>
    `${Config.site_api}/v1/admin/employee-salary/${id}/payments`,

  payEmployeeSalary: (id) =>
    `${Config.site_api}/v1/admin/employee-salary/${id}/pay`,

  cancelEmployeeSalary: (id) =>
    `${Config.site_api}/v1/admin/employee-salary/${id}/cancel`,

  /*
|--------------------------------------------------------------------------
| EMPLOYEE ADVANCE
|--------------------------------------------------------------------------
*/

  getEmployeeAdvanceSummary: `${Config.site_api}/v1/admin/employee-advance/summary`,

  createEmployeeAdvance: `${Config.site_api}/v1/admin/employee-advance/create`,

  getEmployeeAdvances: `${Config.site_api}/v1/admin/employee-advance/list`,

  getEmployeeAdvanceById: (id) =>
    `${Config.site_api}/v1/admin/employee-advance/${id}`,

  updateEmployeeAdvance: (id) =>
    `${Config.site_api}/v1/admin/employee-advance/${id}`,

  recoverEmployeeAdvance: (id) =>
    `${Config.site_api}/v1/admin/employee-advance/${id}/recover`,

  getEmployeeAdvanceRecoveries: (id) =>
    `${Config.site_api}/v1/admin/employee-advance/${id}/recoveries`,

  cancelEmployeeAdvance: (id) =>
    `${Config.site_api}/v1/admin/employee-advance/${id}/cancel`,

  /*
|--------------------------------------------------------------------------
| EMPLOYEE LEAVE TYPE
|--------------------------------------------------------------------------
*/

  getEmployeeLeaveTypes: `${Config.site_api}/v1/admin/employee-leave-types`,

  createEmployeeLeaveType: `${Config.site_api}/v1/admin/employee-leave-types`,

  getEmployeeLeaveTypeById: (id) =>
    `${Config.site_api}/v1/admin/employee-leave-types/${id}`,

  updateEmployeeLeaveType: (id) =>
    `${Config.site_api}/v1/admin/employee-leave-types/${id}`,

  deleteEmployeeLeaveType: (id) =>
    `${Config.site_api}/v1/admin/employee-leave-types/${id}`,

  /*
|--------------------------------------------------------------------------
| EMPLOYEE LEAVE
|--------------------------------------------------------------------------
*/

  createEmployeeLeave: `${Config.site_api}/v1/admin/employee-leaves/create`,

  getEmployeeLeaves: `${Config.site_api}/v1/admin/employee-leaves/list`,

  getEmployeeLeaveBalances: (employeeId, year) =>
    `${Config.site_api}/v1/admin/employee-leaves/balance/${employeeId}?year=${year}`,

  getEmployeeLeaveById: (id) =>
    `${Config.site_api}/v1/admin/employee-leaves/${id}`,

  approveEmployeeLeave: (id) =>
    `${Config.site_api}/v1/admin/employee-leaves/${id}/approve`,

  rejectEmployeeLeave: (id) =>
    `${Config.site_api}/v1/admin/employee-leaves/${id}/reject`,

  cancelEmployeeLeave: (id) =>
    `${Config.site_api}/v1/admin/employee-leaves/${id}/cancel`,

  /*
|--------------------------------------------------------------------------
| EMPLOYEE ATTENDANCE
|--------------------------------------------------------------------------
*/

  saveEmployeeAttendance: `${Config.site_api}/v1/admin/employee-attendance/save`,

  getMyAttendanceStatus: `${Config.site_api}/v1/admin/employee-attendance/self/status`,

  checkInMyAttendance: `${Config.site_api}/v1/admin/employee-attendance/self/check-in`,

  checkOutMyAttendance: `${Config.site_api}/v1/admin/employee-attendance/self/check-out`,

  saveBulkEmployeeAttendance: `${Config.site_api}/v1/admin/employee-attendance/bulk`,

  getEmployeeAttendance: `${Config.site_api}/v1/admin/employee-attendance/list`,

  getEmployeeAttendanceSummary: (employeeId, year, month) =>
    `${Config.site_api}/v1/admin/employee-attendance/summary/${employeeId}?year=${year}&month=${month}`,

  deleteEmployeeAttendance: (id) =>
    `${Config.site_api}/v1/admin/employee-attendance/${id}`,

  // STOREFRONT
  getStorefront: `${Config.site_api}/v1/admin/storefront`,

  updateStorefrontBranding: `${Config.site_api}/v1/admin/storefront/branding`,

  createStorefrontBanner: `${Config.site_api}/v1/admin/storefront/banners`,

  updateStorefrontBanner: (bannerId) =>
    `${Config.site_api}/v1/admin/storefront/banners/${bannerId}`,

  changeStorefrontBannerStatus: (bannerId) =>
    `${Config.site_api}/v1/admin/storefront/banners/${bannerId}/status`,

  deleteStorefrontBanner: (bannerId) =>
    `${Config.site_api}/v1/admin/storefront/banners/${bannerId}`,
};

// WHATSAPP API ENDPOINT
export const whatsappTemplateApi = {
  // sync:
  //     "/v1/admin/whatsapp/templates/sync",
  // list:
  //     "/v1/admin/whatsapp/templates/list",
  // approved:
  //     "/v1/admin/whatsapp/templates/approved",
  // create:
  //     "/v1/admin/whatsapp/templates/create",
  // details: (id) =>
  //     `/v1/admin/whatsapp/templates/${id}`,
  // settings: (id) =>
  //     `/v1/admin/whatsapp/templates/${id}/settings`,
  // toggleStatus: (id) =>
  //     `/v1/admin/whatsapp/templates/${id}/toggle-status`,
  // delete: (id) =>
  //     `/v1/admin/whatsapp/templates/${id}`,
};
